import React from 'react';

const PeopleCaption = () => {
  return (
    <div className="peopleCaption">
      ※航空座席のみ、宿泊のみのご利用はできません。
      <br />※こども料金については下記の通りです。
      <br /><span style={{ paddingLeft: 12 }} />時期によって座席設定が異なりますのでご注意ください。
      <br />
      <br /><span className="title">■日本航空(JAL)、全日空(ANA) </span><span className="smallTitle">(~2026/05/18)</span>
      <br />※3歳以上のお客様は航空座席が必要です。
      <br />※旅行開始日の年齢で選択してください。
      <br /><span style={{ paddingLeft: 12 }} />ただし、2歳の幼児が旅行の途中で3歳になる場合は3歳として選択してください。
      <div className="tableContainer">
        <table>
          <thead>
            <tr>
              <th>こども</th>
              <th>座席</th>
              <th>寝具</th>
              <th>食事</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>6〜11歳</td>
              <td rowSpan={3}>あり</td>
              <td rowSpan={2}>あり</td>
              <td>大人同様</td>
            </tr>
            <tr>
              <td>3〜5歳</td>
              <td>こども用</td>
            </tr>
            <tr>
              <td>3〜5歳</td>
              <td rowSpan={2}>なし</td>
              <td rowSpan={2}>なし</td>
            </tr>
            <tr>
              <td>0〜2歳</td>
              <td>なし</td>
            </tr>
          </tbody>
        </table>
      </div>
      <span className="title">■全日空(ANA)</span><span className="smallTitle">(2026/05/19~)</span>
      <br />※2歳以上のお客様は航空座席が必要です。
      <br />※旅行開始日の年齢で選択してください。
      <br /><span style={{ paddingLeft: 12 }} />ただし、1歳の幼児が旅行の途中で2歳になる場合は2歳として選択してください。
      <div className="tableContainer">
        <table>
          <thead>
            <tr>
              <th>こども</th>
              <th>座席</th>
              <th>寝具</th>
              <th>食事</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>6〜11歳</td>
              <td rowSpan={3}>あり</td>
              <td rowSpan={2}>あり</td>
              <td>大人同様</td>
            </tr>
            <tr>
              <td>3〜5歳</td>
              <td>こども用</td>
            </tr>
            <tr>
              <td>2〜5歳</td>
              <td rowSpan={2}>なし</td>
              <td rowSpan={2}>なし</td>
            </tr>
            <tr>
              <td>0〜1歳</td>
              <td>なし</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PeopleCaption;
